"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResearchOutpost = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const TileType_1 = require("../../TileType");
class ResearchOutpost extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.RESEARCH_OUTPOST,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 18,
            cardDiscount: { amount: 1 },
            metadata: {
                cardNumber: '020',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When you play a card, you pay 1 M€ less for it.', (eb) => {
                        eb.empty().startEffect.megacredits(-1);
                    }).br;
                    b.city();
                }),
                description: 'Place a city tile NEXT TO NO OTHER TILE.',
            },
        });
    }
    getAvailableSpaces(player) {
        const spaces = player.game.board.getAvailableSpacesOnLand(player);
        if (player.cardIsInEffect(CardName_1.CardName.GORDON))
            return spaces;
        return spaces
            .filter((space) => player.game.board.getAdjacentSpaces(space)
            .every((space) => space.tile === undefined));
    }
    canPlay(player) {
        return this.getAvailableSpaces(player).length > 0;
    }
    getCardDiscount() {
        return 1;
    }
    play(player) {
        player.defer(new SelectSpace_1.SelectSpace('Select place next to no other tile for city', this.getAvailableSpaces(player), TileType_1.TileType.CITY, (foundSpace) => {
            player.game.addCityTile(player, foundSpace.id);
            return undefined;
        }), DeferredAction_1.Priority.PLACE_LAND_TILE);
        return undefined;
    }
}
exports.ResearchOutpost = ResearchOutpost;
//# sourceMappingURL=ResearchOutpost.js.map